module.exports = __webpack_public_path__ + "media/images/countryrect/kw-5d2f2bcd0e5f1658938036d7abe1f1b4.svg";